import React from 'react'
import FaExclamation from 'react-icons/lib/fa/exclamation-triangle'

const LicensingErrorAlert = ({ error }) => (
    <div className="row justify-content-center">
        <div className="col-10">
            <div className="add-license add-license--alert error">
                <FaExclamation /> There was a licensing error: {error}
            </div>
        </div>
    </div>
)

export default LicensingErrorAlert
